import React from 'react'
import { Link as MuiLink, LinkProps } from '@mui/material'

import useTidyLink from '../../hooks/useTidyLink'
import { ZipJobConstants } from '../../types/constants'
import { appendZjSpecificTokens } from '../../utils/url'
import { withTwoPassRenderer } from '../../hocs/withTwoPassRenderer'

const ExternalLink: React.FC = React.forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => {
    const tidyTheLink = useTidyLink()

    const { href, ...rest } = props
    const tidyHref = tidyTheLink(href)
    let modifiedHref

    if (tidyHref.includes(ZipJobConstants.ExecutivePurchaseURL)) {
      modifiedHref = appendZjSpecificTokens(tidyHref)
    }

    return <MuiLink ref={ref} {...rest} href={modifiedHref ?? tidyHref} />
  }
)

export default withTwoPassRenderer(ExternalLink)
